/**
 * @file: ErpIntegrationStatus.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum ErpIntegrationStatus {
  Active = 'active',
  Inactive = 'inactive',
}

export const ErpIntegrationStatusValueSet = new Set([
  ErpIntegrationStatus.Active,
  ErpIntegrationStatus.Inactive,
]);
